import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { appConstants } from '../../constants/app.constants';
import { AuthenticationService } from './authentication.service';
import { IbdSdkService } from '../common/ibd-sdk.service';

@Injectable()
export class AuthGuardService {
  constructor(
    private route: Router,
    public authService: AuthenticationService,
    private cookieService: CookieService,
    private ibdSdkService: IbdSdkService
  ) {}

  async canActivate(): Promise<any> {
    if (!(this.cookieService.get(appConstants.LOGGED_IN) && (await this.ibdSdkService.ibd.authenticationManager.loginCheck()))) {
      // TODO: use constants
      this.route.navigateByUrl('/login');
      return false;
    } else if (this.cookieService.check(appConstants.LOGGED_IN)) {
      const isAuthExpired = await this.ibdSdkService.ibd.authenticationManager.isAuthenticationExpired();
      if (isAuthExpired) {
        const isRefreshExpired = this.ibdSdkService.ibd.authenticationManager.refreshAuthentication();
        // TODO: check below code
        if (isRefreshExpired == null) {
          this.authService.logout();
          this.route.navigateByUrl('/login');
          return false;
        }
      }
      return true;
    }
  }
}

@Injectable()
export class LoggedInUserService {
  constructor(private route: Router, private cookieService: CookieService, private ibdSdkService: IbdSdkService, public authService: AuthenticationService) {}
  async canActivate(): Promise<any> {
    if (this.cookieService.check(appConstants.LOGGED_IN) && (await this.ibdSdkService.ibd.authenticationManager.loginCheck())) {
      this.authService.logout();
      this.route.navigateByUrl('/');
      return false;
    } else {
      return true;
    }
  }
}
